<template>
  <div class="table-widget">
    <table v-if="!loading_events && channel_events.length > 0">
      <tr>
        <th>Stream name</th>
        <th>Created Date</th>
        <th>Schedured date</th>
        <th>Status</th>
        <th></th>
      </tr>
      <tr v-for="(item, index) in channel_events" :key="index">
        <td>
          <div class="event-info">
            <h6>{{ item.title }}</h6>
            <div class="sponsored-status">
              <b-tag v-if="item.is_sponsored" type="is-info">Sponsored</b-tag>
            </div>
          </div>
        </td>
        <td>
          <div class="event-date">
            {{ moment(item.created_at).format("DD MMM YYYY H:mm:ss") }}
          </div>
        </td>
        <td>
          <div v-if="item.start_date" class="event-date">
            {{ moment(item.start_date).format("DD MMM YYYY H:mm:ss") }}
          </div>
          <div v-else class="event-date">Date Not Set</div>
        </td>
        <td>
          <div class="event-status">
            <b-tag v-if="item.status == 'active' && item.stream_status == 'pending'" type="is-info" class="status-tag">
              Pending
            </b-tag>
            <b-tag v-if="item.status == 'active' && item.stream_status == 'started'" type="is-success" class="status-tag">
              Live
            </b-tag>
            <b-tag v-if="item.status == 'active' && item.stream_status == 'closed'" type="is-default" class="status-tag">
              Waiting
            </b-tag>

            <b-tag v-if="item.status == 'closed'" type="is-danger" class="status-tag">
              Closed
            </b-tag>
          </div>
        </td>
        <td>
          <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
            <template #trigger>
              <b-icon icon="dots-vertical"></b-icon>
            </template>
            <b-dropdown-item v-if="!item.is_sponsored && item.status == 'active'" @click="setEventAsSponsored(item, true)"
              aria-role="listitem">Set As Sponsored</b-dropdown-item>
            <b-dropdown-item v-if="item.is_sponsored && item.status == 'active'" @click="setEventAsSponsored(item, false)"
              aria-role="listitem">Remove Sponsored</b-dropdown-item>
          </b-dropdown>
        </td>
      </tr>
    </table>
    <table v-if="loading_events">
      <tr>
        <th>Stream name</th>
        <th>Created Date</th>
        <th>Schedured date</th>
        <th>Status</th>
        <th></th>
      </tr>
      <tr v-for="(item, index) in 15" :key="index">
        <td><b-skeleton width="90%"></b-skeleton></td>
        <td><b-skeleton width="90%"></b-skeleton></td>
        <td><b-skeleton width="90%"></b-skeleton></td>
        <td><b-skeleton width="90%"></b-skeleton></td>
        <td><b-skeleton width="90%"></b-skeleton></td>
      </tr>
    </table>
    <widgetNotfound v-if="!loading_events && channel_events.length === 0" title="No streams found"
      subtitle="This partner has no streaming sessions yet">
    </widgetNotfound>
  </div>
</template>
<script>
export default {
  props: {
    channel: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    channel_events: [],
    loading_events: false,
  }),
  mounted() {
    this.getChannelAllEvents();
  },
  methods: {
    getChannelAllEvents() {
      let vm = this;
      vm.loading_events = true;
      vm.$store
        .dispatch("CHANNEL_GET_ALL_EVENTS", { channel_id: vm.channel.id })
        .then((response) => {
          vm.loading_events = false;
          vm.channel_events = response.data.return;
        })
        .catch(() => {
          vm.loading_events = false;
        });
    },
    setEventAsSponsored(item, status) {
      let vm = this;
      vm.$store
        .dispatch("CHANNEL_SET_ITEM_AS_SPONSORED", {
          type: "streaming_event",
          channel_id: vm.channel.id,
          user_id: vm.channel.user_id,
          ref_id: item.id,
          isSponsored: status,
        })
        .then((response) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: response.data.message,
            type: "success",
          });
          vm.getChannelAllEvents();
        })
        .catch(({ response }) => {
          vm.$notify({
            group: "status",
            title: "Message",
            text: response.data.message,
            type: "danger",
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.table-widget {
  overflow-y: auto;
  border-radius: 0;

  table {
    width: 100%;

    tr {
      th {
        white-space: nowrap;
      }

      td {
        white-space: nowrap;
      }
    }
  }
}
</style>
